import { isMobile } from 'helpers';
import { populateViewTileHelper } from 'helpers/RecordsHelper';
import React from 'react';
import { connect } from 'react-redux';
import { ApplicationState, CategoryRecord } from 'types';

export const detailTileHTML = `
<div id="amar-category-detail-record" class="tile amar-category-record detail">
	<div class="record-id">
		<span></span>
	</div>
	<div class="row">
		<div class="col-xs-12 col-md-6 main-details">
			<div class="block">
				<div class="row name-detail">
					<div class="title col-xs-3">
						Name:
					</div>
					<div class="value col-xs-9">
					</div>
				</div>
				<div class="row code-detail">
					<div class="title col-xs-3">
						Code:
					</div>
					<div class="value col-xs-9">
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12 col-md-6 main-details">
			<div class="block">
				<div class="row issues-detail">
					<div class="title col-xs-2">
						Issues Count:
					</div>
					<div class="value city-value col-xs-4">
					</div>
				</div>
				<div class="row period-detail">
					<div class="title col-xs-2">
						Period:
					</div>
					<div class="value tehsil-value col-xs-4">
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
`;

export const briefTileHTML = `
<div id="amar-category-brief-record" class="tile amar-category-record brief">
	<div class="row name-detail">
		<div class="title col-xs-2 col-md-3 no-padding align-right">
			Name:
		</div>
		<div class="value col-xs-10 col-md-9">

		</div>
	</div>
	<div class="row code-detail">
		<div class="title col-xs-2 col-md-3 no-padding align-right">
			Code:
		</div>
		<div class="value col-xs-10 col-md-9">

		</div>
	</div>
	<div class="row issues-detail">
		<div class="title col-xs-2 col-md-3 no-padding align-right">
			Issues Count:
		</div>
		<div class="value col-xs-10 col-md-9">

		</div>
	</div>
	<div class="row period-detail">
		<div class="title col-xs-2 col-md-3 no-padding align-right">
			Period:
		</div>
		<div class="value col-xs-10 col-md-9">

		</div>
	</div>
	<div class="record-id">
		<span></span>
	</div>
</div>
`;

export const detailFormHTML = `
<form id="amar-category-detail-record-form" class="tile amar-category-record detail" method="post" action="javascript:void(0);" enctype="multipart/form-data">
	<div class="record-id">
		<span></span>
	</div>
	<div class="row">
		<div class="col-xs-12 col-md-6 main-details">
			<div class="block">
				<div class="row name-detail">
					<div class="title col-xs-3">
						Name:
					</div>
					<div class="value col-xs-9">
						<input type="text"  name="name" value="" required placeholder="Name"/>
					</div>
				</div>
				<div class="row code-detail">
					<div class="title col-xs-3">
						Code:
					</div>
					<div class="value col-xs-9">
						<input type="text"  name="code" value="" required placeholder="Code"/>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12 col-md-6 main-details">
			<div class="block">
				<div class="row issues-detail">
					<div class="title col-xs-2">
						Issues Count:
					</div>
					<div class="value city-value col-xs-4">
						<input type="number" value="" required name="issues_count" placeholder="Issues Count"/>
					</div>
				</div>
				<div class="row period-detail">
					<div class="title col-xs-2">
						Period:
					</div>
					<div class="value tehsil-value col-xs-4">
						<input type="number" value="" required name="period" placeholder="Period"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>
`;

export const addFormHTML = `
<form id="amar-category-add-record" class="tile amar-category-record detail" method="post" action="javascript:void(0);" enctype="multipart/form-data">
	<div class="row">
		<div class="col-xs-12 col-md-6 main-details">
			<div class="block">
				<div class="row name-detail">
					<div class="title col-xs-3">
						Name:
					</div>
					<div class="value col-xs-9">
						<input type="text"  name="name" value="" required placeholder="Name"/>
					</div>
				</div>
				<div class="row code-detail">
					<div class="title col-xs-3">
						Code:
					</div>
					<div class="value col-xs-9">
						<input type="text"  name="code" value="" required placeholder="Code"/>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12 col-md-6 main-details">
			<div class="block">
				<div class="row issues-detail">
					<div class="title col-xs-2">
						Issues Count:
					</div>
					<div class="value city-value col-xs-4">
						<input type="number" value="" required name="issues_count" placeholder="Issues Count"/>
					</div>
				</div>
				<div class="row period-detail">
					<div class="title col-xs-2">
						Period:
					</div>
					<div class="value tehsil-value col-xs-4">
						<input type="number" value="" required name="period" placeholder="Period"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>
`;

interface Props {
	record?: CategoryRecord;
	index?: number;
	listRef?: React.RefObject<any>;
}

class Component extends React.PureComponent<Props> {
	private tileRef = React.createRef<HTMLDivElement>();

	componentDidMount() {
		populateViewTileHelper(this.tileRef, this.props.record, this.props.index, this.props.listRef);
	}

	componentDidUpdate(prevProps, prevState) {
		populateViewTileHelper(this.tileRef, this.props.record, this.props.index, this.props.listRef);
	}

	render() {
		return (
			<div
				ref={this.tileRef}
				dangerouslySetInnerHTML={{ __html: isMobile() ? briefTileHTML : detailTileHTML }}
			></div>
		);
	}
}

function mapStateToProps(state: ApplicationState) {
	return {};
}

export const ViewTile = connect(mapStateToProps)(Component);
